import React from "react";
import { GiftIcon, CheckIcon, HeartIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { bonuses } from "../../data/bonuses";
export function Bonuses() {
  return <section className="w-full bg-forestDark px-2 py-16 sm:px-4 sm:py-20" data-id="element-107" data-mp="1cko8mjntxicb">
      <div className="mx-auto max-w-4xl" data-id="element-108" data-mp="1citqfd3y04bx">
        <div className="mx-auto max-w-3xl px-2 text-center" data-id="element-109" data-mp="18km6yai3gox1">
          <span className="inline-flex items-center gap-2 rounded-full bg-gold px-4 py-1.5 text-[13px] font-bold uppercase tracking-wider text-white" data-id="element-110" data-mp="259v4favwfttv">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-111" data-mp="20c1ymiyid1u4" /> Exclusive free bonuses
          </span>
          <h2 className="mt-5 font-serif text-[30px] font-bold leading-[1.15] text-white sm:text-5xl" data-id="element-112" data-mp="1w7lw8ro3scjn">
            Today, You'll Also Receive These <em className="text-goldSoft" data-id="element-113" data-mp="ku09te9mop1t">5 Exclusive Bonuses</em>
          </h2>
          <p className="mt-4 text-[17px] leading-relaxed text-white/80" data-id="element-114" data-mp="krx9a0aundiu">
            Five complementary collections designed to make your learning system even more practical.
          </p>
        </div>

        <div className="mt-10 space-y-6" data-id="element-115" data-mp="1erkaou72w03t">
          {bonuses.map(b => <article key={b.number} className="overflow-hidden rounded-3xl bg-white" data-id="element-116" data-mp="1js81bereaexi">
              <div className="bg-sand" data-id="element-117" data-mp="15s701y77x5hi">
                <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="block w-full" loading="lazy" data-id="element-118" data-mp="15vbb9fj3p1ho" />
              </div>
              <div className="px-5 py-6 sm:px-8 sm:py-8" data-id="element-119" data-mp="w2nkb1esxrqv">
                <div className="flex flex-wrap items-center gap-2" data-id="element-120" data-mp="w12pdaoks6sh">
                  <span className="rounded-full bg-forest px-3 py-1 text-[12px] font-bold uppercase tracking-wider text-white" data-id="element-121" data-mp="10unkmuysamnz">
                    Bonus #{b.number}
                  </span>
                  <span className="text-[14px] text-muted" data-id="element-122" data-mp="r4vqg1uljvk1">
                    Suggested value <s className="font-semibold" data-id="element-123" data-mp="d3rqvsarphe3">${b.value}</s> · <strong className="text-cta" data-id="element-124" data-mp="d531aaypxne6">Free today</strong>
                  </span>
                </div>
                <h3 className="mt-3 font-serif text-[24px] font-bold leading-tight text-ink sm:text-3xl" data-id="element-125" data-mp="i5h3hcdn234a">{b.title}</h3>
                <p className="mt-2 text-[16px] leading-relaxed text-muted" data-id="element-126" data-mp="2f1v2qyihkch5">{b.description}</p>
                <ul className="mt-4 space-y-2.5" data-id="element-127" data-mp="2b09md36qtg27">
                  {b.items.map(item => <li key={item} className="flex gap-2.5 text-[16px] text-ink" data-id="element-128" data-mp="2615d6cjtjibv">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-129" data-mp="25z2el44logvj" />
                      {item}
                    </li>)}
                </ul>
                <p className="mt-5 flex gap-2.5 rounded-2xl bg-goldSoft p-4 text-[15px] leading-relaxed text-ink" data-id="element-130" data-mp="2ynzwh64wgbnr">
                  <HeartIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-131" data-mp="2orwtxz64yb0a" />
                  <span data-id="element-132" data-mp="1ibkpjgcpzww9"><strong data-id="element-133" data-mp="1ibb2o1mz25us">Why I included it:</strong> {b.why}</span>
                </p>
              </div>
            </article>)}
        </div>

        <div className="mt-10 px-2" data-id="element-134" data-mp="1dawu8ihgktw8">
          <CtaButton label="Yes! Include all 5 bonuses with my order" data-id="element-135" data-mp="138kt723f1w7h" />
          <p className="mt-4 text-center text-[12px] leading-relaxed text-white/60" data-id="element-136" data-mp="136gcfjkf52ps">
            The standalone values above are suggested reference values, not claims of previous retail prices.
          </p>
        </div>
      </div>
    </section>;
}